$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('link-landing-connect')) {
    customElements.define(
      'link-landing-connect',
      class aboutApplicationScenarios extends HTMLElement {
        connectedCallback() {
          this.initSwiper();
          this.initTableSwiper();
          this.scrollToTop();
        }

        disconnectedCallback() {
          // 清理事件监听器
          if (this.cleanup) {
            this.cleanup();
          }
        }
        scrollToTop() {
          const topContainer = this.querySelector('.link-landing-connect-container-top');
          const imageContainer = this.querySelector('.link-landing-connect-container-image');
          const coverContainer = this.querySelector('.link-landing-connect-container-cover');
          const section = this.querySelector('section');

          if (!topContainer) {
            console.log('未找到 link-landing-connect-container-top 元素');
            return;
          }

          // 🎨 渐变颜色配置 - 最终背景颜色为 rgba(0, 0, 0, 0.4)
          const targetColor = '0, 0, 0'; // 目标颜色：黑色
          const maxOpacity = 0.4; // 最终透明度：0.4

          // 🔘 响应式圆角配置
          let defaultRadius = 60; // 默认圆角：60px

          // 获取响应式圆角值的函数
          const getResponsiveRadius = () => {
            const screenWidth = window.innerWidth;

            // 根据断点设置不同的圆角值
            if (screenWidth < 576) {
              // 576-384断点：20px
              return 20;
            } else if (screenWidth < 1200) {
              // 1200-768断点：40px
              return 40;
            } else if (screenWidth >= 1200) {
              // 大屏幕：60px
              return 60;
            }
            return 60; // 默认值
          };

          // 初始化响应式圆角
          defaultRadius = getResponsiveRadius();
          const minRadius = 0; // 最小圆角：0px

          // 滚动监听函数
          const handleScroll = () => {
            // 动态更新响应式圆角值
            defaultRadius = getResponsiveRadius();

            const topContainerRect = topContainer.getBoundingClientRect();
            const topContainerTop = topContainerRect.top;
            const topContainerHeight = topContainerRect.height;

            // 计算进度：当topContainer接近或离开视口顶部时
            let progress = 0;

            // 定义触发区域：当topContainer在视口内或刚离开顶部时
            if (topContainerTop <= 0 && topContainerTop >= -topContainerHeight) {
              // 计算滚动出视口的比例
              progress = Math.abs(topContainerTop) / topContainerHeight;
            }

            // 确保progress在0-1范围内
            progress = Math.max(0, Math.min(1, progress));

            // 计算当前透明度：从0渐变到0.4
            const currentOpacity = maxOpacity * progress;

            // 背景颜色逻辑：根据滚动位置可逆变化，添加过渡效果
            let backgroundColor;

            // 定义背景颜色过渡区间（与圆角同步）
            const colorTransitionStart = 20; // 开始过渡的位置
            const colorTransitionEnd = 5; // 结束过渡的位置

            if (topContainerTop <= colorTransitionEnd) {
              // 完全接近顶部时，使用固定的0.4透明度黑色
              backgroundColor = `rgba(${targetColor}, 0.4)`;
            } else if (topContainerTop <= colorTransitionStart) {
              // 在过渡区间内，计算渐变透明度
              const transitionProgress =
                (colorTransitionStart - topContainerTop) / (colorTransitionStart - colorTransitionEnd);
              const currentOpacity = 0.4 * transitionProgress;
              backgroundColor = `rgba(${targetColor}, ${currentOpacity})`;
            } else {
              // 远离顶部时，使用透明
              backgroundColor = `rgba(${targetColor}, 0)`;
            }

            // 应用背景颜色，添加CSS过渡效果
            topContainer.style.backgroundColor = backgroundColor;
            topContainer.style.transition = 'background-color 0.3s ease';

            // 圆角逻辑：根据滚动位置可逆变化，添加过渡效果
            let currentRadius = defaultRadius; // 默认60px

            // 定义圆角过渡区间（与背景颜色同步）
            const radiusTransitionStart = 20; // 开始过渡的位置
            const radiusTransitionEnd = 5; // 结束过渡的位置

            if (topContainerTop <= radiusTransitionEnd) {
              // 完全接近顶部时，圆角为0
              currentRadius = 0;
            } else if (topContainerTop <= radiusTransitionStart) {
              // 在过渡区间内，计算渐变圆角
              const transitionProgress =
                (radiusTransitionStart - topContainerTop) / (radiusTransitionStart - radiusTransitionEnd);
              currentRadius = defaultRadius * (1 - transitionProgress);
            } else {
              // 远离顶部时，圆角为默认值
              currentRadius = defaultRadius;
            }

            // 应用圆角到 link-landing-connect-container-image 和 link-landing-connect-container-cover
            if (imageContainer) {
              imageContainer.style.borderTopLeftRadius = `${currentRadius}px`;
              imageContainer.style.borderTopRightRadius = `${currentRadius}px`;
            }
            if (coverContainer) {
              coverContainer.style.borderTopLeftRadius = `${currentRadius}px`;
              coverContainer.style.borderTopRightRadius = `${currentRadius}px`;
            }

            // 调试信息（生产环境可以注释掉）
            // console.log('TopContainerTop:', Math.round(topContainerTop), 'BackgroundColor:', backgroundColor, 'Radius:', currentRadius + 'px');
          };

          // 节流函数，避免滚动事件触发过于频繁
          let ticking = false;
          const throttledHandleScroll = () => {
            if (!ticking) {
              requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
              });
              ticking = true;
            }
          };

          // 绑定滚动事件
          window.addEventListener('scroll', throttledHandleScroll, { passive: true });

          // 绑定窗口调整大小事件
          window.addEventListener('resize', throttledHandleScroll, { passive: true });

          // 初始化时也执行一次
          handleScroll();

          // 在组件销毁时清理事件监听器
          this.cleanup = () => {
            window.removeEventListener('scroll', throttledHandleScroll);
            window.removeEventListener('resize', throttledHandleScroll);
          };
        }
        initSwiper() {
          // 初始化产品 Swiper
          const landingConnectSwiper = this.querySelector('.landing-connect-swiper');
          if (landingConnectSwiper && landingConnectSwiper.getAttribute('data-swiper-initialized') === 'false') {
            const swiperScrollbar = this.querySelector('.swiper-scrollbar');

            landingConnectSwiper.style.maxWidth = '1344px';
            landingConnectSwiper.style.margin = '0 auto';

            new Swiper(landingConnectSwiper, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              freeMode: {
                enabled: true,
                sticky: false,
                momentumBounce: false,
                momentum: true,
                minimumVelocity: 0.02,
              },
              grabCursor: true,
              preventClicks: false,
              preventClicksPropagation: false,
              touchReleaseOnEdges: true,
              resistance: false,
              breakpoints: {
                576: {
                  slidesPerView: 'auto',
                },
                0: {
                  slidesPerView: 1,
                },
              },
              scrollbar: {
                el: swiperScrollbar,
                draggable: true,
                dragSize: 'auto',
                snapOnRelease: false,
                hide: false,
                dragClass: 'swiper-scrollbar-drag',
              },
            });
          }
        }
        initTableSwiper() {
          // 初始化产品 Swiper
          const landingTableSwiper = this.querySelector('.landing-table-swiper');
          console.log('landingTableSwiper', landingTableSwiper);
          if (landingTableSwiper && landingTableSwiper.getAttribute('data-swiper-initialized') === 'false') {
            const swiperScrollbar = landingTableSwiper.querySelector('.swiper-scrollbar');

            landingTableSwiper.style.maxWidth = '1344px';
            landingTableSwiper.style.margin = '0 auto';

            new Swiper(landingTableSwiper, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              freeMode: {
                enabled: true,
                sticky: false,
                momentumBounce: false,
                momentum: true,
                minimumVelocity: 0.02,
              },
              grabCursor: true,
              preventClicks: false,
              preventClicksPropagation: false,
              touchReleaseOnEdges: true,
              resistance: false,
              scrollbar: {
                el: swiperScrollbar,
                draggable: true,
                dragSize: 'auto',
                snapOnRelease: false,
                hide: false,
                dragClass: 'swiper-scrollbar-drag',
              },
            });

            // 标记为已初始化
            landingTableSwiper.setAttribute('data-swiper-initialized', 'true');
          }
        }
      }
    );
  }
});
